import Config from 'react-native-config';
import {fetchApi} from './ApiHelper';
import {Platform} from 'react-native';

export const HTTP_METHODS = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put',
};

import * as Keychain from 'react-native-keychain';

// Guard against native config not loading on iOS; avoid crash on undefined
const RNConfig = Config || {};
export const BASE_URL = RNConfig.API_URL || '';
//export const BASE_URL = 'https://uat-api.diathrive.com/';

export const LOGIN =
  Platform.OS === 'web' ? 'patients/mobile-web-login' : 'patients/login';
export const SEND_OTP = 'patients/send-otp';
export const REFRESH_TOKEN = 'patients/refresh-token';
export const VERIFY_OTP = 'patients/verify-otp';
export const VERIFY_EMAIL = 'patients/verify-email';
export const RESET_PASSWORD = 'patients/reset-password';
export const CREATE_USER = 'patients/create-user';
export const REQUEST_EMP_ID = 'employers/request-unique-id';
export const SUBMIT_EMP_ID = inputId => `employers/${inputId}/verify`;
export const POST_DIABETES_TYPE = 'patients/diabetes-type';
export const CHANGE_PHONE = 'patients/change-phone';
export const CONTACTS = 'patients/contacts';
export const DELETE_CONTACTS = id => 'patients/contacts/' + id;
export const CHANGE_PASSWORD = 'patients/change-password';
export const ACCOUNT_STATUS = 'patients/account-status';
export const UPDATE_USER = 'patients/update-user';
export const RESOURCES = 'patients/resources';
export const RESOURCE_CATEGORY = 'patients/resource-categories';
export const VIEW_DETAILS = 'patients/view-details';
export const FAV_A_RESOURCE = id => `patients/articles/${id}/favourite`;
export const UNFAV_A_RESOURCE = id => `patients/articles/${id}/unfavourite`;
export const BLOOD_SUGAR_LEVEL = 'patients/blood-sugar-level';
export const EXPORT_BLOOD_SUGAR_LEVEL = 'patients/blood-sugar-levels/export';
export const COACHING_ONBOARDED = 'patients/coaching-onboarded';
export const ADDRESSES = 'patients/address';
export const DELETE_ADDRESS = id => 'patients/address/' + id;
export const MAKE_DELETE_ADDRESS_DEFAULT = id =>
  'patients/address/' + id + '/make-default';
export const DELETE_USER = 'patients/delete-user';
export const PRODUCTS = '/employers/products';
export const PRODUCTS_BUY_AGAIN = '/patients/buy-again/products';
export const CREATE_ORDER = '/patients/create-order';
export const PRODUCTS_COUNT = '/employers/products-count';
export const QUANTITY_CHECK = '/employers/products/check-availability';
// includeCancelled: the backend excludes cancelled rows by default so fielded
// pre-2.0 apps (no cancelled state) do not render them as live bookings; this
// app opts in for its Past/Cancelled sections.
export const APPOINTMENTS = 'patients/appointments?includeCancelled=true';
export const CALENDLY_ADVISORS = 'patients/calendly/advisors';
export const CALENDLY_AVAILABLE_TIMES = 'patients/calendly/available-times';
export const CALENDLY_BOOK = 'patients/calendly/book';
export const CALENDLY_CANCEL = 'patients/calendly/cancel';
export const LOG_CLOUDWATCH_EVENT = 'events/cloud-watch/log';
export const CHECK_ELIGIBILTY = 'patients/check-eligibility';

export const loginAndSaveDetailsGlobal = async (email, password) => {
  let postData = {};
  if (Platform.OS === 'web') {
    postData = {
      email,
      password,
    };
  } else {
    //fetch the user details from store
    const credentials = await Keychain.getGenericPassword();
    postData = {
      email: credentials.username,
      password: credentials.password,
    };
  }

  //lpc.setVisible(true);
  return fetchApi(HTTP_METHODS.POST, LOGIN, postData);
};
